



















/* Created- 23 - May - 2019 */
import { Component, Vue, Prop } from "vue-property-decorator";
import SearchPreview from "@/Ui-Components/Article/Search/SearchPreview.vue";
import { ContentSearchHit } from "../../../Generated/ParticaAPI";
import { ParticaEvent, eParticaAction } from "../../../Models/ParticaEvent";

@Component(
	{
		name: "SearchResultsDashboard",
		components: { SearchPreview }
	})
export default class SearchResultsDashboard extends Vue {
	@Prop() private results: ContentSearchHit[];

	private headers: any[] = [
		{ text: "Title", value: "title", sortable: true, align: "left" },
		{ text: "Type", value: "articleType", sortable: true, align: "left" },
		{ text: "Publication", align: "left", sortable: true, value: "publication" },
		{ text: "Issue", value: "issue", sortable: true, align: "left" },
	];

	private selectArticle(hit: ContentSearchHit) {
		this.$emit("partica-event", { action: eParticaAction.ARTICLE_SELECT, item: hit } as ParticaEvent);
	}


	private getType(articleType: number) {
		switch (articleType) {
			case 0:
			case 4: {
				return "Extracted";
			}
			case 1: {
				return "Metadata";
			}
			case 5: {
				return "Syndication";
			}
			case 6: {
				return "Syndication Proof";
			}
			case 7: {
				return "Syndication Rejected";
			}
			case 9: {
				return "Imported";
			}
			case 10: {
				return "Syndication Removed";
			}
			case 11: {
				return "Purchased";
			}
			case 12: {
				return "Written";
			}
			case 13: {
				return "Stream Source";
			}
			case 14: {
				return "Awating Curation";
			}
			case 15: {
				return "Curated";
			}
		}
	}

}
